import axios from 'axios'

async function  delete_assessment(data,token,add_assessments,add_assessment,assessments,dispatch,setDeleting,setMessage,setOpen,navigate){
    try{

    setDeleting(true)
    const deleteAss = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}delete-ass/`,data,{
        headers:{
                "Content-Type":"application/json",
                "Authorization":`Bear ${token}`
            }
    }).catch(err=>{console.log(err)})

        if (deleteAss?.status == 200 && deleteAss?.data.success) {

            const filterData = assessments.filter((item)=>item.id !== data?.id)

            const newTemps = [...filterData]

            await dispatch(add_assessments(newTemps))
            await dispatch(add_assessment([]))

            localStorage.setItem("iTest_assessment",JSON.stringify({}))

            setMessage("Assessment deleted")
            setOpen(true)
            setDeleting(false)
            navigate("/Dashboard")
            
        }else{
            setMessage(deleteAss?.data?.message)
            setOpen(true)
            setDeleting(false)
        }
    }catch(err){
        console.log(err)
        setDeleting(false)
    }
}

export default  delete_assessment